<template>
  <div id="app">
    <Header v-if="showHeader" />
    <router-view id="content" />
    <Footer v-if="showHeader" />
    <Notification />
    <CookieNotification />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import Notification from "./components/Notification.vue";
import CookieNotification from "./components/CookieNotification.vue";
import Vue from "vue";
import { mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    Notification,
    CookieNotification
  },
  computed: {
    ...mapGetters({ 
      showHeader: "showHeader",
      user: "user/user" 
    })
  },
  methods: {
    broadcast() {
      Vue.http.get(`${process.env.VUE_APP_BACKEND_APP}/broadcast/game`);
    },
  }
};
</script>

<style>
@import "./assets/css/app.css";
* {
  box-sizing: border-box;
  margin: 0;
}
main {
  min-height: 100vh;
  padding-bottom: 50px;
}
#app {
  width: 100%;
  height: 100%;
  min-height: 100%;
}
</style>
